// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  border-radius: 0;
}
ion-toolbar p {
  font-family: var(--font);
  font-weight: 700;
  font-size: 20px;
}

ion-item ion-avatar {
  width: 48px;
  height: 48px;
  display: flex;
}
ion-item ion-avatar ion-icon {
  width: 28px;
  height: 28px;
  margin: auto;
}

@media screen and (min-width: 768px) {
  ion-toolbar ion-title p {
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ask-question-list/ask-question-list.page.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AAAI;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAGR;;AACI;EACI,WAAA;EACA,YAAA;EACA,aAAA;AAER;AADQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;AAGZ;;AACA;EAGQ;IACI,gBAAA;EAAV;AACF","sourcesContent":["ion-toolbar{\n    border-radius: 0;\n    p{\n        font-family: var(--font); font-weight: 700;;\n        font-size: 20px;\n    }\n}\nion-item{\n    ion-avatar{\n        width: 48px;\n        height: 48px;\n        display: flex;\n        ion-icon{\n            width: 28px;\n            height: 28px;\n            margin: auto;\n        }\n    }\n}\n@media screen and (min-width: 768px) {\n    ion-toolbar{\n        // border-radius: 37px;\n        ion-title p{\n            text-align: left;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
